import { render } from "./TrainingForm.vue?vue&type=template&id=fbeb8ca4&scoped=true"
import script from "./TrainingForm.vue?vue&type=script&lang=js"
export * from "./TrainingForm.vue?vue&type=script&lang=js"

import "./TrainingForm.vue?vue&type=style&index=0&id=fbeb8ca4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fbeb8ca4"

export default script